module.exports = __webpack_public_path__ + "media/images/gentle_fawn_logo-a61b876e9c249457ecd0e8022d62229f.png";